(function(){
'use strict';
var dataElement=document.getElementById('vopProductData');
if(!dataElement){return;}
var config=JSON.parse(dataElement.textContent);
var galleryGroups=window.estoriaGalleryGroups||{};
var moneyFormat=config.moneyFormat;
var currentHandle=config.currentHandle;
var storefrontRoot=typeof config.rootUrl==='string'&&/^\/(?!\/)[^?#]*$/.test(config.rootUrl)?config.rootUrl:'/';
if(storefrontRoot.slice(-1)!=='/'){storefrontRoot+='/';}
function storefrontPath(path){return storefrontRoot+path.replace(/^\//,'');}
function money(cents){
cents=Math.max(0,Number(cents)||0);
try{
if(window.Shopify&&Shopify.formatMoney){
return Shopify.formatMoney(cents,moneyFormat);
}
}catch(e){}
return '$'+(cents/100).toFixed(2);
}
var currentVariants=config.currentVariants;
var products=config.products;
products[0].variants=currentVariants;
var media=config.media;
currentVariants.forEach(function(variant){
if(variant.featuredMediaId){return;}
var items=galleryItems(variant);
if(!items.length){return;}
variant.img=items[0].thumb;
var button=document.querySelector('#vopMainSwatches [data-id="'+variant.id+'"]');
if(button&&!button.querySelector('img')){
var image=document.createElement('img');
image.src=variant.img;
image.alt=variant.colour;
image.loading='lazy';
button.textContent='';
button.appendChild(image);
}
});
var selectedId=config.selectedId;
var selectedIndex=currentVariants.findIndex(function(v){
return v.id===selectedId;
});
if(selectedIndex<0){
selectedIndex=0;
}
var tier=0;
var discountByTier=[
0,
4000,
9000
];
var activePicker={
tier:null,
slot:null
};
function productByHandle(handle){
return products.find(function(p){
return p.handle===handle;
})||products[0];
}
function variantById(prod,id){
return prod.variants.find(function(v){
return v.id===id;
})||
prod.variants.find(function(v){
return v.available;
})||
prod.variants[0];
}
function defaultVariant(prod){
return prod.variants.find(function(v){
return v.available;
})||null;
}
function makeSlot(prod,variantId){
var v=variantById(prod,variantId);
return{
handle:prod.handle,
variantId:v.id
};
}
var baseProduct=products[0];
var baseVariant=
variantById(
baseProduct,
selectedId
);
var slots=[
[
makeSlot(
baseProduct,
baseVariant.id
)
],
[
makeSlot(
baseProduct,
baseVariant.id
),
makeSlot(
baseProduct,
baseVariant.id
)
],
[
makeSlot(
baseProduct,
baseVariant.id
),
makeSlot(
baseProduct,
baseVariant.id
),
makeSlot(
baseProduct,
baseVariant.id
)
]
];
var track=
document.getElementById(
'vopTrack'
);
var thumbs=
document.getElementById(
'vopThumbs'
);
var dots=
document.getElementById(
'vopDots'
);
var mediaBox=
document.getElementById(
'vopMedia'
);
var current=0;
var total=0;
var startX=0;
var renderedGalleryVariantId=null;
function galleryItems(variant){
if(!variant){return [];}
var usable=media.filter(function(item){return item&&item.src&&(item.type==='image'||item.type==='video');});
var ids=(galleryGroups[currentHandle]||{})[variant.title];
if(ids&&(!variant.featuredMediaId||String(ids[0])===String(variant.featuredMediaId))){
var verified=ids.map(function(id){return usable.find(function(item){return String(item.id)===String(id);});}).filter(Boolean);
if(verified.length===ids.length&&verified.length&&String(verified[0].id)===String(ids[0])){return verified;}
}
// Imported size and material variants often share the product gallery and have no featured media.
// Keep every valid product image; only the explicitly verified legacy map may narrow it.
var featured=usable.find(function(item){return String(item.id)===String(variant.featuredMediaId);});
if(featured){return [featured].concat(usable.filter(function(item){return item!==featured;}));}
if(usable.length){return usable.slice();}
var fallback=variant.img||(products[0]&&products[0].image);
return fallback?[{id:'fallback-'+variant.id,type:'image',src:fallback,thumb:fallback}]:[];
}
function gallery(variant){
// Reuse the current media nodes when bundle changes keep the same variant.
if(variant&&renderedGalleryVariantId===variant.id){go(0);return;}
var items=galleryItems(variant);
track.innerHTML='';
if(thumbs){
thumbs.innerHTML='';
}
if(dots){
dots.innerHTML='';
}
total=items.length;
if(!total){var placeholder=document.createElement('p');placeholder.className='vop-media-empty';placeholder.textContent='Product images are currently unavailable.';placeholder.setAttribute('role','status');track.appendChild(placeholder);}
['vopPrev','vopNext'].forEach(function(id){
var button=document.getElementById(id);
if(button){button.style.display=total>1?'':'none';}
});
items.forEach(function(item,i){
var slide=
document.createElement(
'div'
);
slide.className=
'vop-slide';
slide.dataset.mediaId=String(item.id);
if(item.type==='video'){
var vid=
document.createElement(
'video'
);
vid.src=item.src;
vid.poster=item.poster;
vid.autoplay=true;
vid.muted=true;
vid.loop=true;
vid.setAttribute(
'playsinline',
''
);
vid.setAttribute(
'preload',
'metadata'
);
slide.appendChild(vid);
}else{
var img=
document.createElement(
'img'
);
if(item.srcset){
img.srcset=item.srcset;
img.sizes='(min-width: 1380px) 717px, (min-width: 768px) calc(56vw - 56px), 100vw';
}
if(item.width>0&&item.height>0){img.width=item.width;img.height=item.height;}
img.decoding='async';
if(i===0){img.fetchPriority='high';}
img.src=item.src;
img.alt=config.productTitle+(variant&&variant.title!=='Default Title'?' — '+variant.title:'');
img.loading=
i===0
?'eager'
:'lazy';
slide.appendChild(img);
}
track.appendChild(slide);
if(thumbs){
var b=
document.createElement(
'button'
);
b.type='button';
b.setAttribute('aria-label','View photo '+(i+1));
b.dataset.mediaId=String(item.id);
b.className=
'vop-thumb'+
(i===0?' active':'');
var ti=
document.createElement(
'img'
);
ti.src=item.thumb;
ti.alt='';
ti.loading='lazy';
ti.decoding='async';
b.appendChild(ti);
b.onclick=function(){
go(i);
};
thumbs.appendChild(b);
}
if(dots){
var d=
document.createElement(
'button'
);
d.type='button';
d.className=
'vop-dot'+
(i===0?' active':'');
d.setAttribute(
'aria-label',
'Go to media '+(i+1)
);
d.onclick=function(){
go(i);
};
dots.appendChild(d);
}
});
renderedGalleryVariantId=variant?variant.id:null;
go(0);
}
function go(i){
if(!total){
return;
}
current=
(i+total)%total;
track.style.transform=
'translateX(-'+
(current*100)+
'%)';
if(thumbs){
thumbs
.querySelectorAll(
'.vop-thumb'
)
.forEach(function(b,n){
b.classList.toggle(
'active',
n===current
);
});
}
if(dots){
dots
.querySelectorAll(
'.vop-dot'
)
.forEach(function(d,n){
d.classList.toggle(
'active',
n===current
);
});
}
}
function syncCurrentVariant(id){
var v=
currentVariants.find(function(x){
return x.id===id;
});
if(purchasePending||!v||!v.available){
return;
}
selectedId=id;
document
.getElementById(
'vopVariantInput'
)
.value=id;
var colour=
document.getElementById(
'vopColourName'
);
if(colour){
colour.textContent=v.colour;
}
renderMainOptions();
slots.forEach(function(t){
if(t[0].handle===currentHandle){
t[0].variantId=id;
}
});
gallery(v);
try{
var url=
new URL(location.href);
url.searchParams.set(
'variant',
id
);
history.replaceState(
{},
'',
url
);
}catch(e){}
renderAllSlots();
updatePrices();
}
window.vopMainSelect=function(btn){
syncCurrentVariant(
parseInt(
btn.dataset.id
)
);
};
function uniqueOptionValues(prod,index){
return prod.variants.reduce(function(values,variant){
var value=(variant.options||[])[index];
if(value!=null&&values.indexOf(value)<0){values.push(value);}
return values;
},[]);
}
function productOptions(prod){
return (prod.optionNames||[]).slice(0,3).map(function(name,index){
return {name:String(name||('Option '+(index+1))),index:index,values:uniqueOptionValues(prod,index)};
}).filter(function(option){return option.values.length&&!(option.name.toLowerCase()==='title'&&option.values.length===1&&String(option.values[0]).toLowerCase()==='default title');});
}
function resolveOptionVariant(prod,current,index,value){
var matches=prod.variants.filter(function(variant){return variant.available&&(variant.options||[])[index]===value;});
var best=null,bestScore=-1;
matches.forEach(function(variant){
var score=(variant.options||[]).reduce(function(sum,option,i){return sum+(i!==index&&option===(current.options||[])[i]?1:0);},0);
if(score>bestScore){best=variant;bestScore=score;}
});
return best;
}
function optionMarkup(prod,variant,prefix){
return productOptions(prod).map(function(option){
var value=(variant.options||[])[option.index];
var colour=/colou?r/i.test(option.name);
var html='<div class="vop-option-group"><span class="vop-label">'+escapeHtml(option.name.toUpperCase())+': <strong>'+escapeHtml(value)+'</strong></span><div class="'+(colour?'vop-swatches':'vop-slot-sizes')+'">';
option.values.forEach(function(optionValue){
var next=resolveOptionVariant(prod,variant,option.index,optionValue);
var display=next||prod.variants.find(function(item){return (item.options||[])[option.index]===optionValue;});
var image=colour?variantImage(prod,display):'';
var selected=value===optionValue;
html+='<button type="button" class="'+(colour?'vop-swatch':'vop-size-pill')+(selected?' active':'')+'" data-'+prefix+'-option="'+option.index+'" data-option-value="'+escapeAttr(optionValue)+'" aria-label="'+escapeAttr(option.name+': '+optionValue+(next?'':' — unavailable'))+'" aria-pressed="'+selected+'"'+(!next?' disabled':'')+'>'+(image?'<img src="'+escapeAttr(image)+'" alt="" loading="lazy">':escapeHtml(optionValue))+'</button>';
});
return html+'</div></div>';
}).join('');
}
function restoreOptionFocus(box,prefix,index,value){
var replacement=Array.from(box.querySelectorAll('[data-'+prefix+'-option]')).find(function(button){return Number(button.getAttribute('data-'+prefix+'-option'))===index&&button.getAttribute('data-option-value')===value;});
if(replacement){replacement.focus({preventScroll:true});}
}
function renderMainOptions(){
var box=document.getElementById('vopMainOptions');
if(!box){return;}
var prod=products[0];
box.innerHTML=optionMarkup(prod,variantById(prod,selectedId),'main');
box.querySelectorAll('[data-main-option]').forEach(function(button){
button.onclick=function(){
if(purchasePending){return;}
var index=Number(this.getAttribute('data-main-option'));
var value=this.getAttribute('data-option-value');
var next=resolveOptionVariant(prod,variantById(prod,selectedId),index,value);
if(!next){return;}
syncCurrentVariant(next.id);
var status=document.getElementById('vopSelectionStatus');
if(status){status.textContent=next.title;}
restoreOptionFocus(box,'main',index,value);
};
});
}
function variantImage(prod,v){
return(
(v&&v.img) ||
prod.image ||
''
);
}
function realOptions(prod){
return(
prod.variants.length>1 &&
!(
prod.variants.length===1 &&
String(
prod.variants[0].title
)
.toLowerCase()
==='default title'
)
);
}
function slotMarkup(t,s){
var state=slots[t-1][s-1];
var prod=productByHandle(state.handle);
var variant=variantById(prod,state.variantId);
state.variantId=variant.id;
var html='<div class="vop-slot-rule"></div><div class="vop-slot-top"><div class="vop-slot-label">ITEM '+s+'</div>';
if(s>1){html+='<button type="button" class="vop-change" data-tier="'+t+'" data-slot="'+s+'" aria-label="Choose item '+s+' from any category"><span class="vop-change-title">MIX ITEMS</span><span class="vop-change-chevron" aria-hidden="true">⌄</span></button>';}
html+='</div><div class="vop-slot-product"><div class="vop-slot-image">'+(variantImage(prod,variant)?'<img src="'+escapeAttr(variantImage(prod,variant))+'" alt="" loading="lazy">':'')+'</div><div class="vop-slot-product-copy"><div class="vop-slot-product-name">'+escapeHtml(prod.title)+'</div><div class="vop-slot-product-price">'+money(variant.price)+'</div></div></div>';
return html+optionMarkup(prod,variant,'slot');
}
function escapeHtml(str){
return String(str||'')
.replace(
/[&<>"']/g,
function(m){
return({
'&':'&amp;',
'<':'&lt;',
'>':'&gt;',
'"':'&quot;',
"'":'&#039;'
})[m];
}
);
}
function escapeAttr(str){
return escapeHtml(str);
}
function restoreSlotControlFocus(t,s,selector,attribute,value){
var box=document.getElementById('vopSlot'+t+'_'+s);
if(!box){return;}
var target=Array.from(box.querySelectorAll(selector)).find(function(control){return control.getAttribute(attribute)===String(value);});
if(target){target.focus({preventScroll:true});}
}
function renderSlot(t,s){
var box=document.getElementById('vopSlot'+t+'_'+s);
if(!box){return;}
box.innerHTML=slotMarkup(t,s);
var change=box.querySelector('.vop-change');
if(change){change.onclick=function(event){event.stopPropagation();openPicker(t,s);};}
box.querySelectorAll('[data-slot-option]').forEach(function(button){
button.onclick=function(event){
event.stopPropagation();
if(purchasePending){return;}
var index=Number(this.getAttribute('data-slot-option'));
var value=this.getAttribute('data-option-value');
var state=slots[t-1][s-1];
var prod=productByHandle(state.handle);
var next=resolveOptionVariant(prod,variantById(prod,state.variantId),index,value);
if(!next){return;}
state.variantId=next.id;
if(s===1&&state.handle===currentHandle){syncCurrentVariant(next.id);}else{renderSlot(t,s);updatePrices();}
restoreOptionFocus(box,'slot',index,value);
};
});
}
function renderAllSlots(){
renderSlot(1,1);
renderSlot(2,1);
renderSlot(2,2);
renderSlot(3,1);
renderSlot(3,2);
renderSlot(3,3);
}
function tierSubtotal(t){
return slots[t].reduce(function(sum,state){
var variant=variantById(productByHandle(state.handle),state.variantId);
return sum+(variant&&Number.isFinite(variant.price)?Math.max(0,variant.price):0);
},0);
}
function tierDiscount(t){
// Only merchandise unlocks an offer; protection remains payable in full.
// A bag with its included charm is still one qualifying slot.
var count=0;
var eligibleSubtotal=0;
slots[t].forEach(function(state){
var product=productByHandle(state.handle);
var productId=String(product.id||'').replace('gid://shopify/Product/','');
if(productId==='8148262191182'||productId==='8141791101006'||product.handle==='shipping-protection'||product.handle==='shipping-protection-warranty'){return;}
var variant=variantById(product,state.variantId);
count+=1;
eligibleSubtotal+=variant&&Number.isFinite(variant.price)?Math.max(0,variant.price):0;
});
var reward=count>=3?discountByTier[2]:(count>=2?discountByTier[1]:0);
return Math.min(eligibleSubtotal,reward);
}
function tierTotal(t){
return Math.max(0,tierSubtotal(t)-tierDiscount(t));
}
function updatePrices(){
refreshPurchaseAvailability();
syncStickySelection();
document
.getElementById(
'vopBundlePrice1'
)
.textContent=
money(
tierTotal(0)
);
document
.getElementById(
'vopBundlePrice2'
)
.textContent=
money(
tierTotal(1)
);
document
.getElementById(
'vopBundlePrice3'
)
.textContent=
money(
tierTotal(2)
);
[0,1,2].forEach(function(index){
var bundle=document.getElementById('vopBundle'+(index+1));
var discount=tierDiscount(index);
var label=bundle.querySelector('.vop-bundle-title');
if(label){label.textContent=index===0?'Single one':'Buy '+(index+1)+(discount?' & Save '+money(discount):' items');}
var save=bundle.querySelector('.vop-bundle-save');
if(save){save.hidden=!discount;save.textContent=discount?'SAVE '+money(discount):'';}
var gift=bundle.querySelector('.venora-offer-gift');
var gifts=slots[index].filter(function(state){return giftEligible(state.handle);}).length;
if(gift){gift.hidden=!gifts;gift.textContent=gifts?'+ '+gifts+' free charm'+(gifts===1?'':'s'):'';}
});
var activeTotal=tierTotal(tier);
document
.getElementById(
'vopMainPrice'
)
.textContent=
money(activeTotal);
var was=
document.getElementById(
'vopWasPrice'
);
var saving=
document.getElementById(
'vopSaving'
);
if(tier===0){
saving.textContent='';
saving.hidden=true;
var p=
productByHandle(
slots[0][0].handle
);
var v=
variantById(
p,
slots[0][0].variantId
);
if(v.compare>v.price){
was.style.display='inline';
was.textContent=
money(v.compare);
}else{
was.style.display='none';
}
}else{
was.style.display='none';
var discount=tierDiscount(tier);
saving.hidden=!discount;
saving.textContent=discount?'Bundle saving: '+money(discount):'';
}
}
window.vopSelectBundle=
function(n){
if(purchasePending){return;}
tier=n-1;
[1,2,3]
.forEach(function(x){
document
.getElementById(
'vopBundle'+x
)
.classList.toggle(
'active',
x===n
);
var control=document.getElementById('vopBundleToggle'+x);
control.setAttribute('aria-expanded',String(x===n));
control.setAttribute('aria-pressed',String(x===n));
var content=document.getElementById('vopSlots'+x);
content.hidden=x!==n;
content.inert=x!==n;
content.setAttribute('aria-hidden',String(x!==n));
});
var first=
slots[tier][0];
var p=
productByHandle(
first.handle
);
var v=
variantById(
p,
first.variantId
);
if(
first.handle===currentHandle &&
v
){
document
.getElementById(
'vopVariantInput'
)
.value=v.id;
var cv=
currentVariants.find(
function(x){
return x.id===v.id;
}
);
if(cv){
gallery(cv);
}
}
syncCheckoutRoute();
updatePrices();
};
var picker=
document.getElementById(
'vopPicker'
);
var backdrop=
document.getElementById(
'vopPickerBackdrop'
);
var search=
document.getElementById(
'vopSearch'
);
var grid=
document.getElementById(
'vopPickerGrid'
);
var noResults=
document.getElementById(
'vopNoResults'
);
var pickerCategory=document.getElementById('vopPickerCategory');
var pickerStatus=document.getElementById('vopPickerStatus');
var pickerMore=document.getElementById('vopPickerMore');
var pickerRetry=document.getElementById('vopPickerRetry');
var pickerState={generation:0,page:0,nextPage:null,loading:false,query:'',category:'all',results:[],controller:null,loadedAt:0};
var pickerSearchTimer=null;
var pickerProductRequest=0;
// Only small, successful summary pages are cached. Selection still validates live product data.
var pickerCache=new Map();
var pickerCacheLimit=16;
var pickerCacheTTL=120000;
function cachedPickerPage(key){
var entry=pickerCache.get(key);
if(!entry){return null;}
if(Date.now()-entry.createdAt>=pickerCacheTTL){pickerCache.delete(key);return null;}
pickerCache.delete(key);pickerCache.set(key,entry);
return entry;
}
function rememberPickerPage(key,data){
var entry={data:data,createdAt:Date.now()};
pickerCache.delete(key);pickerCache.set(key,entry);
while(pickerCache.size>pickerCacheLimit){pickerCache.delete(pickerCache.keys().next().value);}
return entry;
}
function pickerSelectedHandle(){
var selected=activePicker.tier&&slots[activePicker.tier-1][activePicker.slot-1];
return selected?selected.handle:null;
}
function syncPickerSelectedCard(){
var selectedHandle=pickerSelectedHandle();
grid.querySelectorAll('.vop-product-card').forEach(function(card){
var selected=card.dataset.handle===selectedHandle;
card.classList.toggle('current',selected);
card.setAttribute('aria-pressed',String(selected));
var pill=card.querySelector('.vop-current-pill');
if(selected&&!pill){pill=document.createElement('span');pill.className='vop-current-pill';pill.textContent='Selected item';card.querySelector('.vop-card-media').appendChild(pill);}
else if(!selected&&pill){pill.remove();}
});
}

function pickerMessage(message,error){
pickerStatus.textContent=message||'';
pickerStatus.classList.toggle('is-error',!!error);
}
function pickerResultCard(prod){
var card=document.createElement('button');
card.type='button';
var selected=prod.handle===pickerSelectedHandle();
card.className='vop-product-card'+(selected?' current':'');
card.setAttribute('aria-pressed',String(selected));
card.dataset.handle=prod.handle;
card.disabled=!prod.available;
card.innerHTML='<div class="vop-card-media">'+(prod.image?'<img src="'+escapeAttr(prod.image)+'" alt="" loading="lazy" decoding="async">':'<span class="vop-card-placeholder">No image available</span>')+(selected?'<span class="vop-current-pill">Selected item</span>':'')+'</div><div class="vop-card-info"><div class="vop-card-title">'+escapeHtml(prod.title)+'</div><div class="vop-card-bottom"><span class="vop-card-price">'+money(prod.price)+'</span><span class="vop-card-options">'+(prod.available?(prod.variantCount>1?prod.variantCount+' options':'1 option'):'Sold out')+'</span></div></div>';
card.addEventListener('click',function(){chooseProduct(prod.handle,card);});
return card;
}
function renderPickerResults(){
var fragment=document.createDocumentFragment();
pickerState.results.forEach(function(prod){fragment.appendChild(pickerResultCard(prod));});
grid.replaceChildren(fragment);
noResults.style.display=!pickerState.loading&&!pickerState.results.length?'block':'none';
pickerMore.hidden=!pickerState.nextPage;
pickerMore.disabled=pickerState.loading;
pickerMore.textContent=pickerState.loading?'Loading…':'Load more';
grid.setAttribute('aria-busy',String(pickerState.loading));
}
function pickerPageURL(page){
var path=pickerState.query?'search':'collections/'+encodeURIComponent(pickerState.category);
var url=new URL(storefrontPath(path),location.origin);
url.searchParams.set('view','venora-picker');
url.searchParams.set('page',String(page));
if(pickerState.query){url.searchParams.set('q',pickerState.query);url.searchParams.set('type','product');url.searchParams.set('options[prefix]','last');}
return url.toString();
}
function validatePickerPage(data,page){
if(!data||!Array.isArray(data.products)||Number(data.page)!==page||data.products.length>24){throw new Error('INVALID_CATALOG_RESPONSE');}
data.products.forEach(function(prod){
if(!prod||typeof prod.handle!=='string'||!prod.handle||typeof prod.title!=='string'||!Number.isSafeInteger(prod.price)||typeof prod.available!=='boolean'||!Number.isInteger(prod.variantCount)||prod.variantCount<1){throw new Error('INVALID_CATALOG_PRODUCT');}
});
return data;
}
function showPickerPage(entry,page){
var data=entry.data;
var seen=Object.create(null);
pickerState.results.forEach(function(prod){seen[prod.handle]=true;});
data.products.forEach(function(prod){if(!seen[prod.handle]){pickerState.results.push(prod);seen[prod.handle]=true;}});
pickerState.page=page;
pickerState.nextPage=Number(data.nextPage)>page?Number(data.nextPage):null;
pickerState.loadedAt=pickerState.loadedAt?Math.min(pickerState.loadedAt,entry.createdAt):entry.createdAt;
pickerState.loading=false;
pickerRetry.hidden=true;
renderPickerResults();
var shown=pickerState.results.length;
pickerMessage(shown?(shown+' product'+(shown===1?'':'s')+' shown.'):'No products found. Try a different search or category.',false);
return true;
}
function loadPickerPage(page,reset){
if(reset){
if(pickerState.controller){pickerState.controller.abort();}
pickerState.generation++;
pickerState.results=[];
pickerState.page=0;
pickerState.nextPage=null;
pickerState.loadedAt=0;
}else if(pickerState.loading){return Promise.resolve(false);}
var generation=pickerState.generation;
var url=pickerPageURL(page);
var cached=cachedPickerPage(url);
if(cached){pickerState.controller=null;return Promise.resolve(showPickerPage(cached,page));}
var controller=typeof AbortController==='function'?new AbortController():null;
pickerState.controller=controller;
pickerState.loading=true;
pickerRetry.hidden=true;
pickerMessage('Loading products…',false);
renderPickerResults();
var timeout=controller?window.setTimeout(function(){controller.abort();},12000):null;
return fetch(url,{credentials:'same-origin',signal:controller?controller.signal:undefined})
.then(function(response){if(!response.ok){throw new Error('CATALOG_LOAD_FAILED');}return response.json();})
.then(function(data){
if(generation!==pickerState.generation){return false;}
validatePickerPage(data,page);
return showPickerPage(rememberPickerPage(url,data),page);
}).catch(function(error){
if(generation!==pickerState.generation){return false;}
pickerState.loading=false;
renderPickerResults();
pickerRetry.hidden=false;
pickerRetry.dataset.page=String(page);
pickerMessage('Products could not be loaded. Please try again.',true);
return false;
}).finally(function(){if(timeout!==null){window.clearTimeout(timeout);}});
}
function resumePickerResults(){
var query=search.value.trim();
var category=query?'all':pickerCategory.value||'all';
if(query===pickerState.query&&category===pickerState.category&&pickerState.page>0&&Date.now()-pickerState.loadedAt<pickerCacheTTL){
// Reuse the existing cards and scroll position; do not decode their images again on reopen.
pickerState.loading=false;
pickerRetry.hidden=true;
pickerMore.disabled=false;
pickerMore.textContent='Load more';
grid.setAttribute('aria-busy','false');
syncPickerSelectedCard();
var shown=pickerState.results.length;
pickerMessage(shown?(shown+' product'+(shown===1?'':'s')+' shown.'):'No products found. Try a different search or category.',false);
return Promise.resolve(true);
}
return resetPickerResults();
}
function resetPickerResults(){
pickerProductRequest++;
pickerState.query=search.value.trim();
// Search is global so results are never silently restricted to the first category page.
if(pickerState.query){pickerCategory.value='all';}
pickerState.category=pickerCategory.value||'all';
var scroller=picker.querySelector('.vop-picker-scroll');
if(scroller){scroller.scrollTop=0;}
return loadPickerPage(1,true);
}
function normalizePickerProduct(product,handle){
if(!product||product.handle!==handle||!Array.isArray(product.variants)||!product.variants.length){throw new Error('This item is no longer available. Please choose another.');}
var variants=product.variants.map(function(variant){
if(!Number.isSafeInteger(variant.id)||!Number.isSafeInteger(variant.price)||typeof variant.available!=='boolean'){throw new Error('This item could not be checked. Please try again.');}
var image=variant.featured_image;
return {id:variant.id,title:variant.title,options:variant.options||[variant.option1,variant.option2,variant.option3].filter(function(value){return value!=null;}),colour:variant.option1,price:variant.price,compare:variant.compare_at_price||0,available:variant.available,img:typeof image==='string'?image:(image&&image.src)||product.featured_image||null,featuredMediaId:variant.featured_media&&variant.featured_media.id||0};
});
var result={id:product.id,handle:handle,title:product.title,image:product.featured_image||null,optionNames:(product.options||[]).map(function(option){return typeof option==='string'?option:option.name;}),variants:variants};
if(!defaultVariant(result)){throw new Error('This item is currently sold out. Please choose another.');}
return result;
}
async function chooseProduct(handle,card){
if(!activePicker.tier||purchasePending||pickerState.loading){return;}
var selection={tier:activePicker.tier,slot:activePicker.slot};
var request=++pickerProductRequest;
var controller=typeof AbortController==='function'?new AbortController():null;
var timeout=controller?window.setTimeout(function(){controller.abort();},10000):null;
if(card){card.disabled=true;card.setAttribute('aria-busy','true');}
pickerMessage('Checking this item and its options…',false);
try{
var checked=await Promise.all([
fetch(storefrontPath('products/'+encodeURIComponent(handle)+'.js'),{credentials:'same-origin',cache:'no-store',signal:controller?controller.signal:undefined}),
legacyGiftEligible(handle)?Promise.resolve(null):fetchProductCharmMap(handle,controller?controller.signal:undefined)
]);
var response=checked[0];
if(!response.ok){throw new Error('This item is no longer available. Please choose another.');}
var prod=normalizePickerProduct(await response.json(),handle);
if(request!==pickerProductRequest||activePicker.tier!==selection.tier||activePicker.slot!==selection.slot||purchasePending){return;}
var existing=products.findIndex(function(product){return product.handle===handle;});
if(existing===0){
// The rendered main form and gallery use this page's variant snapshot. Do not silently
// discard fresh price/stock changes or add an item with an outdated displayed price.
var unchanged=prod.variants.length===currentVariants.length&&prod.variants.every(function(fresh){
var rendered=currentVariants.find(function(variant){return variant.id===fresh.id;});
return rendered&&rendered.price===fresh.price&&rendered.available===fresh.available&&JSON.stringify(rendered.options)===JSON.stringify(fresh.options);
});
if(!unchanged){throw new Error('This item has changed. Refresh this page before adding it to your set.');}
prod=products[0];
}
if(checked[1]){registerProductCharmMap(prod,checked[1]);}
if(existing<0){products.push(prod);}else if(existing>0){products[existing]=prod;}
var variant=defaultVariant(prod);
slots[selection.tier-1][selection.slot-1]={handle:handle,variantId:variant.id};
closePicker();
renderSlot(selection.tier,selection.slot);
updatePrices();
}catch(error){
if(request===pickerProductRequest&&activePicker.tier===selection.tier&&activePicker.slot===selection.slot){pickerMessage(error.name==='AbortError'||error instanceof TypeError?'Unable to check this item. Please try again.':error.message,true);}
}finally{
if(timeout!==null){window.clearTimeout(timeout);}
if(card&&card.isConnected){card.disabled=false;card.removeAttribute('aria-busy');}
}
}
var pickerTrigger=null;
var pickerRestoreSlot=null;
var pickerFocusTimer=null;
var pickerBackground=[];
function setPickerBackgroundInert(active){
if(!active){
pickerBackground.forEach(function(entry){entry.element.inert=entry.inert;});
pickerBackground=[];
return;
}
var branch=picker;
while(branch.parentElement){
var parent=branch.parentElement;
Array.from(parent.children).forEach(function(element){
if(element===branch||element===backdrop||/^(SCRIPT|STYLE|LINK)$/.test(element.tagName)){return;}
pickerBackground.push({element:element,inert:element.inert});
element.inert=true;
});
if(parent===document.body){break;}
branch=parent;
}
}
function pickerFocusable(){
return Array.from(picker.querySelectorAll('button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function(element){return !element.hidden&&element.getClientRects().length>0;});
}
function openPicker(t,s){
if(purchasePending){return;}
activePicker={tier:t,slot:s};
pickerTrigger=document.activeElement;
pickerRestoreSlot={tier:t,slot:s};
document.getElementById('vopPickerSub').textContent='Choose item '+s+' from any category.';
resumePickerResults();
picker.hidden=false;
picker.inert=false;
picker.setAttribute('aria-hidden','false');
picker.classList.add('open');
backdrop.classList.add('open');
document.body.classList.add('vop-picker-lock');
setPickerBackgroundInert(true);
updateStickyVisibility();
clearTimeout(pickerFocusTimer);
pickerFocusTimer=setTimeout(function(){
if(picker.classList.contains('open')){search.focus({preventScroll:true});}
},0);
}
function closePicker(){
if(!picker.classList.contains('open')){return;}
clearTimeout(pickerFocusTimer);
clearTimeout(pickerSearchTimer);
pickerProductRequest++;
if(pickerState.controller){pickerState.controller.abort();}
pickerState.generation++;
pickerState.loading=false;
picker.classList.remove('open');
picker.hidden=true;
picker.inert=true;
picker.setAttribute('aria-hidden','true');
backdrop.classList.remove('open');
document.body.classList.remove('vop-picker-lock');
setPickerBackgroundInert(false);
updateStickyVisibility();
activePicker={tier:null,slot:null};
var restore=pickerRestoreSlot;
var trigger=pickerTrigger;
requestAnimationFrame(function(){
var slot=restore&&document.getElementById('vopSlot'+restore.tier+'_'+restore.slot);
var target=slot&&slot.querySelector('.vop-change');
if(!target&&trigger&&trigger.isConnected){target=trigger;}
if(target){target.focus({preventScroll:true});}
});
}
function handlePickerKeydown(e){
if(!picker.classList.contains('open')){return;}
if(e.key==='Escape'){e.preventDefault();closePicker();return;}
if(e.key!=='Tab'){return;}
var controls=pickerFocusable();
if(!controls.length){e.preventDefault();return;}
var first=controls[0],last=controls[controls.length-1];
if(e.shiftKey&&(document.activeElement===first||!picker.contains(document.activeElement))){e.preventDefault();last.focus();}
else if(!e.shiftKey&&(document.activeElement===last||!picker.contains(document.activeElement))){e.preventDefault();first.focus();}
}
search.addEventListener('input',function(){
clearTimeout(pickerSearchTimer);
pickerProductRequest++;
// Invalidate immediately: a slower prior response cannot replace a newer search.
pickerState.generation++;
if(pickerState.controller){pickerState.controller.abort();}
pickerSearchTimer=setTimeout(resetPickerResults,300);
});
pickerCategory.addEventListener('change',function(){clearTimeout(pickerSearchTimer);search.value='';resetPickerResults();});
pickerMore.addEventListener('click',function(){if(pickerState.nextPage){loadPickerPage(pickerState.nextPage,false);}});
pickerRetry.addEventListener('click',function(){loadPickerPage(Number(this.dataset.page)||1,false);});
document
.getElementById(
'vopPickerClose'
)
.onclick=
closePicker;
backdrop.onclick=
closePicker;
document.addEventListener('keydown',handlePickerKeydown);
var purchasePending=false;
// Each eligible bag/charm pair must resolve to a verified native bundle parent.
var giftChoice=document.getElementById('venoraGiftChoice');
var giftSelections=giftChoice?['44569370689614']:[];
var nativeBundleSettings=null;
var nativeBundleState={status:giftChoice?'idle':'not-needed',index:null,error:null};
var nativeBundleLoadGeneration=0;
var nativeParentCache=Object.create(null);
var nativeProductBundleStates=Object.create(null);
function legacyGiftEligible(handle){
return Array.isArray(config.giftEligibleHandles)&&config.giftEligibleHandles.indexOf(handle)>=0;
}
function giftEligible(handle){
var product=products.find(function(item){return item.handle===handle;});
return legacyGiftEligible(handle)||!!(product&&product.charmBundleConfigured);
}
function bundleStateForProduct(handle){
return legacyGiftEligible(handle)?nativeBundleState:nativeProductBundleStates[handle]||{status:'error',index:null,error:nativeBundleFailure()};
}
function selectedLegacyGift(){
return slots[tier].some(function(slot){return legacyGiftEligible(slot.handle);});
}
function giftLimit(){
return slots[tier].filter(function(state){return giftEligible(state.handle);}).length;
}
function giftOption(variantId){
if(!giftChoice){return null;}
return Array.prototype.find.call(giftChoice.options,function(option){return option.value===String(variantId);})||null;
}
function giftSelectionComplete(){
return giftLimit()===0||!!giftChoice&&(giftSelections.length===giftLimit()&&giftSelections.every(function(id){return !!giftOption(id);}));
}
function usesNativeProductCheckout(){
// Product wallets are bound to the rendered product, not a cross-product bundle ID.
return tier===0&&!giftEligible(currentHandle)&&giftLimit()===0;
}
function syncCheckoutRoute(){
var useNative=usesNativeProductCheckout();
var dynamic=document.getElementById('vopDynamic');
var custom=document.getElementById('vopCustomBuy');
dynamic.hidden=!useNative;
dynamic.style.display=useNative?'block':'none';
custom.hidden=useNative;
custom.style.display=useNative?'none':'block';
return useNative;
}
function nativeBundleError(code,message){
var error=new Error(message);
error.code=code;
return error;
}
function nativeVariantId(value){
if(typeof value==='number'&&!Number.isSafeInteger(value)){return null;}
var match=/^(?:gid:\/\/shopify\/ProductVariant\/)?([1-9][0-9]*)$/.exec(String(value));
return match?match[1]:null;
}
function nativeBundleFailure(){
return nativeBundleError('INVALID_MAPPING','We could not verify this bag and charm offer. Please try again.');
}
function readNativeBundleSettings(){
if(nativeBundleSettings){return nativeBundleSettings;}
var element=document.getElementById('venoraNativeBundleConfig');
var settings=element?JSON.parse(element.textContent):null;
if(!settings||settings.schemaVersion!==1||typeof settings.shop!=='string'||!settings.shop||!/^\/(?!\/)[^?#]*$/.test(settings.rootUrl)||!/^[A-Z]{3}$/.test(settings.currency)){throw nativeBundleFailure();}
nativeBundleSettings=settings;
return settings;
}
function fetchProductCharmMap(handle,signal){
// Product Ajax JSON does not contain metafields. Check only the item being selected,
// alongside its fresh variants; cached catalogue summaries never decide gift eligibility.
return fetch(storefrontPath('products/'+encodeURIComponent(handle)+'?view=venora-charm-map'),{credentials:'same-origin',cache:'no-store',signal:signal})
.then(function(response){if(!response.ok){throw nativeBundleFailure();}return response.json();});
}
function registerProductCharmMap(product,payload){
if(!payload||payload.schemaVersion!==2||payload.handle!==product.handle||!product.id||String(payload.productId)!==String(product.id)||typeof payload.configured!=='boolean'){throw nativeBundleFailure();}
product.charmBundleConfigured=payload.configured;
if(!payload.configured){delete nativeProductBundleStates[product.handle];return;}
try{
nativeProductBundleStates[product.handle]={status:'ready',index:buildNativeBundleIndex(payload.map,product),error:null};
}catch(error){
// Presence means the promised gift cannot be silently dropped if its map is damaged.
nativeProductBundleStates[product.handle]={status:'error',index:null,error:error&&error.code?error:nativeBundleFailure()};
}
}
function initializeCurrentCharmMapping(){
if(legacyGiftEligible(currentHandle)){return;}
try{
var payload=readNativeBundleSettings().currentProduct;
if(payload){registerProductCharmMap(products[0],payload);}
else if(products[0].charmBundleConfigured){throw nativeBundleFailure();}
}catch(error){
if(products[0].charmBundleConfigured){nativeProductBundleStates[currentHandle]={status:'error',index:null,error:nativeBundleFailure()};}
}
}
function reloadProductCharmMapping(product){
var existing=nativeProductBundleStates[product.handle];
if(existing&&existing.status==='loading'){return existing.promise;}
var entry={status:'loading',index:null,error:null,promise:null};
nativeProductBundleStates[product.handle]=entry;
var controller=typeof AbortController==='function'?new AbortController():null;
var timeout=controller?window.setTimeout(function(){controller.abort();},8000):null;
entry.promise=fetchProductCharmMap(product.handle,controller?controller.signal:undefined)
.then(function(payload){
if(payload.configured!==true){throw nativeBundleError('NOT_ENABLED','This bag and charm offer is not ready to purchase. Please try again later.');}
registerProductCharmMap(product,payload);
return nativeProductBundleStates[product.handle].status==='ready';
}).catch(function(error){
nativeProductBundleStates[product.handle]={status:'error',index:null,error:error&&error.code?error:nativeBundleError('LOAD_FAILED','We could not load your bag and charm offer. Check your connection and try again.')};
return false;
}).finally(function(){if(timeout!==null){window.clearTimeout(timeout);}refreshPurchaseAvailability();});
refreshPurchaseAvailability();
return entry.promise;
}
function reloadSelectedBundleMappings(){
if(purchasePending){return Promise.resolve(false);}
var requests=[],seen=Object.create(null);
if(selectedLegacyGift()){requests.push(loadNativeBundleMapping());}
slots[tier].forEach(function(slot){
if(legacyGiftEligible(slot.handle)||!giftEligible(slot.handle)||seen[slot.handle]){return;}
seen[slot.handle]=true;
requests.push(reloadProductCharmMapping(productByHandle(slot.handle)));
});
nativeParentCache=Object.create(null);
return Promise.all(requests).then(function(results){refreshPurchaseAvailability();return results.every(function(result){return result;});});
}
function buildNativeBundleIndex(manifest,sourceProduct){
readNativeBundleSettings();
var perProduct=!!sourceProduct;
var expectedRevision=perProduct?nativeBundleSettings.productMapRevision:nativeBundleSettings.revision;
if(!manifest||manifest.schemaVersion!==(perProduct?2:1)||typeof expectedRevision!=='string'||!expectedRevision||manifest.revision!==expectedRevision){
throw nativeBundleError('STALE_REVISION','This offer has been updated. Refresh the page and try again.');
}
if(perProduct&&(manifest.sourceHandle!==sourceProduct.handle||!sourceProduct.id||String(manifest.sourceProductId)!==String(sourceProduct.id))){throw nativeBundleFailure();}
if(manifest.enabled!==true){throw nativeBundleError('NOT_ENABLED','This bag and charm offer is not ready to purchase. Please try again later.');}
if(typeof nativeBundleSettings.shop!=='string'||!nativeBundleSettings.shop||!/^[A-Z]{3}$/.test(nativeBundleSettings.currency)||manifest.shop!==nativeBundleSettings.shop||!Array.isArray(manifest.mappings)||typeof manifest.verifiedAt!=='string'||!Number.isFinite(Date.parse(manifest.verifiedAt))){
throw nativeBundleFailure();
}
if(manifest.currency!==nativeBundleSettings.currency){throw nativeBundleError('CURRENCY_UNSUPPORTED','This bag and charm offer is not available in your selected currency. Please contact Support@venorastyle.com.');}
if(!perProduct&&(manifest.offerDiscountsVerified!==true||!manifest.offerDiscountsMinor||manifest.offerDiscountsMinor['2']!==discountByTier[1]||manifest.offerDiscountsMinor['3']!==discountByTier[2])){
throw nativeBundleError('DISCOUNTS_UNVERIFIED','We could not verify the savings for this offer. Please try again.');
}
var bagVariants=Object.create(null);
(perProduct?[sourceProduct]:products).forEach(function(product){
if(!perProduct&&!legacyGiftEligible(product.handle)){return;}
product.variants.forEach(function(variant){bagVariants[nativeVariantId(variant.id)]=variant;});
});
var index=Object.create(null);
var parentPairs=Object.create(null);
var parentHandles=Object.create(null);
var parentProducts=Object.create(null);
manifest.mappings.forEach(function(record){
if(!record){throw nativeBundleFailure();}
var bagId=nativeVariantId(record.bagVariantId);
var charmId=nativeVariantId(record.charmVariantId);
var parentId=nativeVariantId(record.parentVariantId);
if(!bagId||!charmId||!parentId||bagId===charmId||!bagVariants[bagId]||!giftOption(charmId)||bagVariants[parentId]||giftOption(parentId)||record.requiresComponents!==true){throw nativeBundleFailure();}
if(!/^[1-9][0-9]*$/.test(String(record.parentProductId))||typeof record.parentHandle!=='string'||!record.parentHandle||typeof record.publishedOnlineStore!=='boolean'||typeof record.available!=='boolean'){
throw nativeBundleFailure();
}
if(!Number.isSafeInteger(record.parentPriceMinor)||record.parentPriceMinor<=0||record.parentPriceMinor!==record.bagPriceMinor||record.currency!==manifest.currency){
throw nativeBundleError('PRICE_MISMATCH','The price of this offer has changed. Refresh the page and try again.');
}
if(perProduct&&(record.bagPriceMinor!==bagVariants[bagId].price||record.status!=='UNLISTED'||!/^[a-z0-9][a-z0-9-]*$/.test(record.parentHandle))){throw nativeBundleFailure();}
if(!Array.isArray(record.components)||record.components.length!==2){throw nativeBundleFailure();}
var componentIds=record.components.map(function(component){
if(!component||component.quantity!==1){throw nativeBundleFailure();}
return nativeVariantId(component.variantId);
});
if(componentIds.indexOf(bagId)<0||componentIds.indexOf(charmId)<0){throw nativeBundleFailure();}
var key=bagId+':'+charmId;
if(index[key]||parentPairs[parentId]||(parentHandles[record.parentHandle]&&parentHandles[record.parentHandle]!==String(record.parentProductId))||(parentProducts[String(record.parentProductId)]&&parentProducts[String(record.parentProductId)]!==record.parentHandle)){throw nativeBundleFailure();}
parentPairs[parentId]=key;
parentHandles[record.parentHandle]=String(record.parentProductId);
parentProducts[String(record.parentProductId)]=record.parentHandle;
index[key]=Object.freeze({
parentVariantId:parentId,parentProductId:String(record.parentProductId),parentHandle:record.parentHandle,priceMinor:record.parentPriceMinor,currency:record.currency,
available:record.available&&record.publishedOnlineStore&&(record.status==='ACTIVE'||record.status==='UNLISTED')
});
});
if(perProduct){
var charmIds=Array.prototype.map.call(giftChoice.options,function(option){return option.value;});
Object.keys(bagVariants).forEach(function(bagId){
charmIds.forEach(function(charmId){if(!index[bagId+':'+charmId]){throw nativeBundleFailure();}});
});
if(Object.keys(index).length!==Object.keys(bagVariants).length*charmIds.length){throw nativeBundleFailure();}
}
return Object.freeze(index);
}
function fetchNativeParentProduct(record,force){
var key=record.parentHandle;
var cached=nativeParentCache[key];
if(cached&&(!force||cached.status==='loading')){return cached.promise||Promise.resolve(cached.status==='ready');}
var entry={status:'loading',variants:null,error:null,promise:null};
nativeParentCache[key]=entry;
var root=nativeBundleSettings.rootUrl||'/';
if(!/^\/(?!\/)[^?#]*$/.test(root)){entry.status='error';entry.error=nativeBundleFailure();return Promise.resolve(false);}
if(root.charAt(root.length-1)!=='/'){root+='/';}
var controller=typeof AbortController==='function'?new AbortController():null;
var timeout=controller?window.setTimeout(function(){controller.abort();},8000):null;
entry.promise=fetch(root+'products/'+encodeURIComponent(key)+'.js',{credentials:'same-origin',cache:'no-store',signal:controller?controller.signal:undefined})
.then(function(response){if(!response.ok){throw nativeBundleFailure();}return response.json();})
.then(function(product){
if(!product||String(product.id)!==record.parentProductId||product.handle!==key||!Array.isArray(product.variants)){throw nativeBundleFailure();}
var variants=Object.create(null);
product.variants.forEach(function(variant){
var id=nativeVariantId(variant.id);
if(!id||variants[id]||!Number.isSafeInteger(variant.price)||variant.price<=0||typeof variant.available!=='boolean'){throw nativeBundleFailure();}
variants[id]={price:variant.price,available:variant.available};
});
entry.status='ready';entry.variants=variants;
return true;
}).catch(function(){
entry.status='error';entry.error=nativeBundleError('PARENT_LOAD_FAILED','We could not check this bag and charm offer. Please try again.');
return false;
}).finally(function(){
if(timeout!==null){window.clearTimeout(timeout);}
if(nativeParentCache[key]===entry){refreshPurchaseAvailability();}
});
return entry.promise;
}
function refreshSelectedNativeParents(force){
if(!giftSelectionComplete()||!selectionAvailable()){return Promise.resolve(false);}
var seen=Object.create(null);
var requests=[];
var giftIndex=0;
slots[tier].forEach(function(slot){
if(!giftEligible(slot.handle)){return;}
var state=bundleStateForProduct(slot.handle);
var charmId=giftSelections[giftIndex++];
var record=state.status==='ready'&&state.index[nativeVariantId(slot.variantId)+':'+charmId];
if(record&&record.available&&!seen[record.parentHandle]){
seen[record.parentHandle]=true;
requests.push(fetchNativeParentProduct(record,force));
}
});
return Promise.all(requests).then(function(results){return results.every(function(result){return result;});});
}
function nativeBundleItems(){
var items=[];
var giftIndex=0;
selectedVariants().forEach(function(variant,slotIndex){
if(!variant){throw nativeBundleError('BAG_UNAVAILABLE','One of your selected items is unavailable. Please choose an available option.');}
var id=nativeVariantId(variant.id);
if(giftEligible(slots[tier][slotIndex].handle)){
var state=bundleStateForProduct(slots[tier][slotIndex].handle);
if(state.status==='loading'||state.status==='idle'){throw nativeBundleError('LOADING','Preparing your bag and charm…');}
if(state.status!=='ready'){throw state.error||nativeBundleFailure();}
var charmId=giftSelections[giftIndex++];
var record=state.index[id+':'+charmId];
if(!record||!record.available){throw nativeBundleError('PAIR_UNAVAILABLE','This bag and charm combination is unavailable. Choose another bag or charm.');}
var parent=nativeParentCache[record.parentHandle];
if(!parent||parent.status==='loading'){throw nativeBundleError('LOADING','Checking your bag and charm…');}
if(parent.status!=='ready'){throw parent.error||nativeBundleFailure();}
var parentVariant=parent.variants[record.parentVariantId];
if(!parentVariant||!parentVariant.available){throw nativeBundleError('PAIR_UNAVAILABLE','This bag and charm combination is unavailable. Choose another bag or charm.');}
if(parentVariant.price!==variant.price||record.currency!==nativeBundleSettings.currency){
throw nativeBundleError('PRICE_MISMATCH','The price of this offer has changed. Refresh the page and try again.');
}
id=record.parentVariantId;
}
if(!id){throw nativeBundleFailure();}
var item=items.find(function(existing){return existing.id===id;});
if(item){item.quantity++;}else{items.push({id:id,quantity:1});}
});
return items;
}
function nativeBundleSelection(){
if(!selectionAvailable()||!giftSelectionComplete()){return {items:null,error:null};}
try{return {items:nativeBundleItems(),error:null};}
catch(error){return {items:null,error:error};}
}
function loadNativeBundleMapping(){
if(!giftChoice||purchasePending||!selectedLegacyGift()){return Promise.resolve(false);}
var generation=++nativeBundleLoadGeneration;
nativeBundleState={status:'loading',index:null,error:null};
nativeParentCache=Object.create(null);
refreshPurchaseAvailability();
try{
readNativeBundleSettings();
if(typeof nativeBundleSettings.url!=='string'||!nativeBundleSettings.url){throw nativeBundleFailure();}
}catch(error){
nativeBundleState={status:'error',index:null,error:nativeBundleFailure()};
refreshPurchaseAvailability();
return Promise.resolve(false);
}
var controller=typeof AbortController==='function'?new AbortController():null;
var timeout=controller?window.setTimeout(function(){controller.abort();},8000):null;
return fetch(nativeBundleSettings.url,{credentials:'omit',cache:'no-store',signal:controller?controller.signal:undefined})
.then(function(response){if(!response.ok){throw nativeBundleFailure();}return response.json();})
.then(function(manifest){
if(generation!==nativeBundleLoadGeneration){return false;}
nativeBundleState={status:'ready',index:buildNativeBundleIndex(manifest),error:null};
refreshPurchaseAvailability();
return true;
}).catch(function(error){
if(generation!==nativeBundleLoadGeneration){return false;}
nativeBundleState={status:'error',index:null,error:error&&error.code?error:nativeBundleError('LOAD_FAILED','We could not load your bag and charm offer. Check your connection and try again.')};
refreshPurchaseAvailability();
return false;
}).finally(function(){if(timeout!==null){window.clearTimeout(timeout);}});
}
function syncGiftSelection(){
if(!giftChoice){return;}
var limit=giftLimit();
var giftWrapper=document.getElementById('venoraGift');
if(giftWrapper){giftWrapper.hidden=limit===0;}
// Preserve choices on upgrades; remove the most recently added gifts on downgrades.
giftSelections=giftSelections.filter(function(id){return !!giftOption(id);}).slice(0,limit);
giftChoice.value=giftSelections[0]||'';
var status=document.getElementById('venoraGiftCount');
var remaining=limit-giftSelections.length;
if(status){
status.textContent='You can choose up to '+limit+' free charm'+(limit===1?'':'s');
}
giftChoice.disabled=purchasePending;
document.querySelectorAll('[data-venora-gift-card]').forEach(function(card){
var id=card.getAttribute('data-venora-gift-card');
var count=giftSelections.filter(function(selectedId){return selectedId===id;}).length;
card.classList.toggle('is-selected',count>0);
card.querySelector('[data-venora-gift-quantity]').textContent=String(count);
card.querySelector('[data-venora-gift-minus]').disabled=purchasePending||count===0;
card.querySelector('[data-venora-gift-plus]').disabled=purchasePending||remaining===0;
});
}
function adjustGiftQuantity(id,delta){
id=String(id);
if(purchasePending||!giftOption(id)){return;}
if(delta===1&&giftSelections.length<giftLimit()){giftSelections.push(id);}
else if(delta===-1){
var index=giftSelections.lastIndexOf(id);
if(index>=0){giftSelections.splice(index,1);}
}
refreshPurchaseAvailability();
}
if(giftChoice){
document.querySelectorAll('[data-venora-gift-plus]').forEach(function(button){
button.addEventListener('click',function(){adjustGiftQuantity(button.getAttribute('data-venora-gift-plus'),1);});
});
document.querySelectorAll('[data-venora-gift-minus]').forEach(function(button){
button.addEventListener('click',function(){adjustGiftQuantity(button.getAttribute('data-venora-gift-minus'),-1);});
});
var bundleRetry=document.getElementById('venoraBundleRetry');
if(bundleRetry){bundleRetry.addEventListener('click',reloadSelectedBundleMappings);}
}
var nativeGiftForm=document.querySelector('#vopDynamic form');
if(nativeGiftForm){nativeGiftForm.addEventListener('submit',function(event){
var ready=refreshPurchaseAvailability();
if(!ready||!usesNativeProductCheckout()){
event.preventDefault();
event.stopImmediatePropagation();
}
},true);}
function selectedVariants(){
return slots[tier].map(function(state){
var prod=products.find(function(p){return p.handle===state.handle;});
return prod&&prod.variants.find(function(v){return v.id===state.variantId;});
});
}
function selectionAvailable(){
return selectedVariants().every(function(v){return v&&v.available;});
}
function refreshPurchaseAvailability(){
syncGiftSelection();
if(!purchasePending&&selectedLegacyGift()&&nativeBundleState.status==='idle'){loadNativeBundleMapping();}
if(!purchasePending){refreshSelectedNativeParents(false);}
var available=selectionAvailable();
var giftComplete=giftSelectionComplete();
var missingGiftPicker=giftLimit()>0&&!giftChoice;
var bundleSelection=nativeBundleSelection();
var bundleError=bundleSelection.error;
var blocked=purchasePending||!available||!giftComplete||!!bundleError;
var bundleLabel=bundleError&&bundleError.code==='LOADING'?'CHECKING OFFER':'OFFER UNAVAILABLE';
var atc=document.getElementById('vopAtc');
var buy=document.getElementById('vopCustomBuy');
atc.disabled=blocked;
buy.disabled=blocked;
atc.textContent=purchasePending?'ADDING...':(!available?'SELECT AVAILABLE ITEMS':(!giftComplete?(missingGiftPicker?'OFFER UNAVAILABLE':'CHOOSE YOUR CHARMS'):(bundleError?bundleLabel:'ADD TO BAG')));
buy.textContent=purchasePending?'PLEASE WAIT...':(!available?'SELECT AVAILABLE ITEMS':(!giftComplete?(missingGiftPicker?'OFFER UNAVAILABLE':'CHOOSE YOUR CHARMS'):(bundleError?bundleLabel:'BUY NOW')));
var stickyButton=document.getElementById('vopStickyAtc');
if(stickyButton){
stickyButton.disabled=blocked;
stickyButton.textContent=purchasePending?'Adding…':(!available?'Unavailable':(!giftComplete?(missingGiftPicker?'Offer unavailable':'Choose charms'):(bundleError?'Offer unavailable':'Add to cart')));
stickyButton.setAttribute('aria-busy',String(purchasePending));
}
var dynamic=document.getElementById('vopDynamic');
var useNative=syncCheckoutRoute();
dynamic.inert=blocked||!useNative;
dynamic.setAttribute('aria-disabled',String(blocked||!useNative));
var nativeInput=document.getElementById('vopVariantInput');
if(nativeInput){
nativeInput.disabled=blocked||!useNative;
if(!useNative){nativeInput.value='';}
}
var bundleNotice=document.getElementById('venoraBundleNotice');
var bundleMessage=document.getElementById('venoraBundleMessage');
var retry=document.getElementById('venoraBundleRetry');
if(bundleNotice){bundleNotice.hidden=!bundleError;}
if(bundleMessage){bundleMessage.textContent=bundleError?bundleError.message:'';}
if(retry){retry.hidden=!bundleError||bundleError.code==='LOADING';retry.disabled=purchasePending||!!(bundleError&&bundleError.code==='LOADING');}
var status=document.getElementById('vopPurchaseStatus');
if(!available){status.hidden=false;status.textContent='One of your selected items is unavailable. Please choose an available option.';}
else if(missingGiftPicker){status.hidden=false;status.textContent='We could not load the charm choices. Refresh the page and try again.';}
else if(!giftComplete){status.hidden=false;status.textContent='Choose '+giftLimit()+' free charm'+(giftLimit()===1?'':'s')+' in total — one for each bag — before continuing.';}
else if(bundleError){status.hidden=false;status.textContent=bundleError.message;}
else if(!purchasePending){status.hidden=true;status.textContent='';}
syncStickyPurchaseStatus();
return !blocked;
}
function activeItems(){
if(!selectionAvailable()){throw new Error('One of your selected items is unavailable. Please choose an available option.');}
if(giftLimit()>0&&!giftChoice){throw new Error('We could not load the charm choices. Refresh the page and try again.');}
if(!giftSelectionComplete()){throw new Error('Please choose exactly one free charm for each bag before continuing.');}
return nativeBundleItems();
}
function addItems(items){
return fetch(storefrontPath('cart/add.js'),{
method:'POST',
headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
body:JSON.stringify({items:items})
}).then(function(response){
return response.json().catch(function(){return {};}).then(function(data){
if(!response.ok){throw new Error(typeof data.description==='string'?data.description:'Your items could not be added. Please try again.');}
return data;
});
});
}
function nativePurchaseSelectionKey(){
return JSON.stringify({tier:tier,slots:slots[tier],gifts:giftSelections});
}
function submitPurchase(destination){
if(purchasePending){return Promise.resolve(false);}
var items;
try{items=activeItems();}catch(error){
refreshPurchaseAvailability();
return Promise.resolve(false);
}
var selectionKey=nativePurchaseSelectionKey();
purchasePending=true;
refreshPurchaseAvailability();
return refreshSelectedNativeParents(true).then(function(){
if(nativePurchaseSelectionKey()!==selectionKey){throw new Error('Your selection changed while we checked the offer. Please review your choices and try again.');}
items=activeItems();
return addItems(items);
}).then(function(){
if(destination==='checkout'){location.href=storefrontPath('checkout');return true;}
return vopRefreshCartSections().then(function(cd){
vopOpenCartDrawer(cd);
purchasePending=false;
refreshPurchaseAvailability();
if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){publish(PUB_SUB_EVENTS.cartUpdate,{source:'vop-product'});}
return true;
}).catch(function(){
location.href=storefrontPath('cart');
return true;
});
}).catch(function(error){
purchasePending=false;
refreshPurchaseAvailability();
var status=document.getElementById('vopPurchaseStatus');
status.hidden=false;
status.textContent=error instanceof TypeError?'Unable to connect. Please try again.':error.message;
syncStickyPurchaseStatus();
return false;
});
}
function syncStickySelection(){
var title=document.getElementById('vopStickyTitle');
var selection=document.getElementById('vopStickySelection');
var price=document.getElementById('vopStickyPrice');
if(!title||!selection||!price){return;}
var descriptions=slots[tier].map(function(state){
var prod=productByHandle(state.handle);
var variant=prod.variants.find(function(v){return v.id===state.variantId;});
return prod.title+(variant&&variant.title!=='Default Title'?' — '+variant.title:'');
});
title.textContent=tier===0?productByHandle(slots[tier][0].handle).title:(tier+1)+' items selected';
selection.textContent=descriptions.join(' + ');
selection.title=descriptions.join(' + ');
price.textContent=money(tierTotal(tier));
}
function syncStickyPurchaseStatus(){
var status=document.getElementById('vopPurchaseStatus');
var stickyStatus=document.getElementById('vopStickyStatus');
if(status&&stickyStatus){
stickyStatus.hidden=status.hidden;
stickyStatus.textContent=status.hidden?'':status.textContent;
}
}
function stickyOverlayOpen(){
if(document.body.classList.contains('vop-picker-lock')){return true;}
return Array.from(document.querySelectorAll('dialog[open], details.menu-drawer-container[open], details-modal details[open], cart-drawer.active, quick-add-modal[open]')).some(function(element){
// Native drawers and details keep dialog markup in the DOM while closed.
for(var ancestor=element;ancestor;ancestor=ancestor.parentElement){
if(ancestor.hidden||ancestor.getAttribute('aria-hidden')==='true'||ancestor.matches('details:not([open])')){return false;}
var style=window.getComputedStyle(ancestor);
if(style.display==='none'||style.visibility==='hidden'){return false;}
}
return element.getClientRects().length>0;
});
}
function stickyShouldShow(ctaBottom,overlayOpen,inputFocused,footerTop,viewportHeight){
var footerClear=typeof footerTop!=='number'||footerTop>=viewportHeight;
// Show only after the main purchase button has fully scrolled above the viewport.
return ctaBottom<=0&&!overlayOpen&&!inputFocused&&footerClear;
}
function updateStickyPreviewOffset(sticky){
var viewportHeight=window.innerHeight;
var offset=0;
document.querySelectorAll('iframe#PBarNextFrame, iframe#preview-bar-iframe, iframe[title*="preview bar" i]').forEach(function(frame){
var style=window.getComputedStyle(frame);
var rect=frame.getBoundingClientRect();
if(style.position==='fixed'&&style.display!=='none'&&style.visibility==='visible'&&rect.width>0&&rect.height>0&&rect.height<=viewportHeight/2&&rect.bottom>=viewportHeight-1){
offset=Math.max(offset,viewportHeight-rect.top,0);
}
});
var value=offset+'px';
if(sticky.style.getPropertyValue('--vop-preview-offset')!==value){sticky.style.setProperty('--vop-preview-offset',value);}
}
function updateStickyVisibility(){
var sticky=document.getElementById('vopSticky');
var main=document.getElementById('vopAtc');
if(!sticky||!main){return;}
var active=document.activeElement;
var typing=!!(active&&active.matches('input, textarea, select, [contenteditable="true"]'));
var ctaBottom=main.getBoundingClientRect().bottom;
var show=false;
// Most scrolling happens above the purchase button: skip overlay/iframe scans there.
if(ctaBottom<=0&&!typing){
var footer=document.querySelector('footer.footer');
var footerTop=footer?footer.getBoundingClientRect().top:undefined;
show=stickyShouldShow(ctaBottom,stickyOverlayOpen(),typing,footerTop,window.innerHeight);
}
if(show){updateStickyPreviewOffset(sticky);}
if(sticky.hidden===!show){return;}
sticky.hidden=!show;
sticky.inert=!show;
sticky.setAttribute('aria-hidden',String(!show));
}
function initStickyPurchase(){
var sticky=document.getElementById('vopSticky');
var main=document.getElementById('vopAtc');
if(!sticky||!main){return;}
if(typeof window.vopStickyCleanup==='function'){window.vopStickyCleanup();}
// Keep fixed glass outside the product section's filtered/transformed ancestors.
document.body.appendChild(sticky);
document.body.classList.add('vop-has-sticky-purchase');
var frame=null;
function schedule(){
if(frame!==null){return;}
frame=requestAnimationFrame(function(){frame=null;updateStickyVisibility();});
}
window.addEventListener('scroll',schedule,{passive:true});
window.addEventListener('resize',schedule,{passive:true});
document.addEventListener('focusin',schedule);
document.addEventListener('focusout',schedule);
var observer=typeof MutationObserver==='function'?new MutationObserver(schedule):null;
if(observer){observer.observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['class','open','aria-hidden']});}
var intersection=typeof IntersectionObserver==='function'?new IntersectionObserver(schedule,{threshold:0}):null;
if(intersection){
intersection.observe(main);
var footer=document.querySelector('footer.footer');
if(footer){intersection.observe(footer);}
}
function cleanup(){
window.removeEventListener('scroll',schedule);
window.removeEventListener('resize',schedule);
document.removeEventListener('focusin',schedule);
document.removeEventListener('focusout',schedule);
document.removeEventListener('shopify:section:unload',onSectionUnload);
if(observer){observer.disconnect();}
if(intersection){intersection.disconnect();}
if(frame!==null){cancelAnimationFrame(frame);}
if(sticky.isConnected){sticky.remove();}
document.body.classList.remove('vop-has-sticky-purchase');
}
function onSectionUnload(event){if(event.target.contains(dataElement)){cleanup();}}
document.addEventListener('shopify:section:unload',onSectionUnload);
window.vopStickyCleanup=cleanup;
syncStickySelection();
syncStickyPurchaseStatus();
updateStickyVisibility();
}

function vopRefreshCartSections(){
return fetch(
storefrontPath('cart/update.js'),
{
method:'POST',
headers:{
'Content-Type':'application/json',
'Accept':'application/json',
'X-Requested-With':'XMLHttpRequest'
},
body:JSON.stringify({
updates:{},
sections:[
'cart-drawer',
'cart-icon-bubble'
],
sections_url:
window.location.pathname
})
}
)
.then(function(r){
if(!r.ok){
throw new Error(
'Cart section refresh failed'
);
}
return r.json();
})
.then(function(data){
if(
data.sections &&
data.sections[
'cart-drawer'
]
){
var doc=
new DOMParser()
.parseFromString(
data.sections[
'cart-drawer'
],
'text/html'
);
var fresh=
doc.querySelector(
'#CartDrawer'
);
var current=
document.querySelector(
'#CartDrawer'
);
if(
!fresh ||
!current
){
throw new Error(
'Custom cart drawer markup missing'
);
}
current.innerHTML=
fresh.innerHTML;
}else{
throw new Error(
'cart-drawer section missing'
);
}
if(
data.sections &&
data.sections[
'cart-icon-bubble'
]
){
var bdoc=
new DOMParser()
.parseFromString(
data.sections[
'cart-icon-bubble'
],
'text/html'
);
var freshBubble=
bdoc.querySelector(
'.shopify-section'
);
var bubble=
document.getElementById(
'cart-icon-bubble'
);
if(
freshBubble &&
bubble
){
bubble.innerHTML=
freshBubble.innerHTML;
}
}
var cd=
document.querySelector(
'cart-drawer'
);
var overlay=
document.querySelector(
'#CartDrawer-Overlay'
);
if(
cd &&
overlay &&
typeof cd.close==='function'
){
overlay.addEventListener(
'click',
cd.close.bind(cd)
);
}
return cd;
});
}
function vopOpenCartDrawer(cd){
cd=
cd||
document.querySelector(
'cart-drawer'
);
if(!cd){
throw new Error(
'Cart drawer component missing'
);
}
cd.classList.remove(
'is-empty'
);
requestAnimationFrame(
function(){
requestAnimationFrame(
function(){
if(
typeof cd.open==='function'
){
cd.open();
}else{
cd.classList.add(
'active'
);
document.body
.classList.add(
'overflow-hidden'
);
}
}
);
}
);
}
function vopAddAndOpen(items){
return addItems(items)
.then(function(){
return vopRefreshCartSections();
})
.then(function(cd){
vopOpenCartDrawer(cd);
return cd;
});
}
window.vopAddToCart=function(){return submitPurchase('cart');};
window.vopBuyNow=function(){return submitPurchase('checkout');};
function restorePurchaseAfterHistory(event){
if(event.persisted){
purchasePending=false;
refreshPurchaseAvailability();
reloadSelectedBundleMappings();
}
}
window.addEventListener('pageshow',restorePurchaseAfterHistory);
document
.getElementById(
'vopPrev'
)
.onclick=
function(){
go(
current-1
);
};
document
.getElementById(
'vopNext'
)
.onclick=
function(){
go(
current+1
);
};
mediaBox.addEventListener(
'touchstart',
function(e){
startX=
e.touches[0]
.clientX;
},
{
passive:true
}
);
mediaBox.addEventListener(
'touchend',
function(e){
var d=
startX-
e.changedTouches[0]
.clientX;
if(
Math.abs(d)>38
){
go(
d>0
?current+1
:current-1
);
}
},
{
passive:true
}
);
// Start the floating control before optional gallery and picker rendering.
initializeCurrentCharmMapping();
refreshPurchaseAvailability();
initStickyPurchase();
renderMainOptions();
renderAllSlots();
var initial=
currentVariants[
selectedIndex
]||
currentVariants[0];
if(initial){
gallery(initial);
}
vopSelectBundle(1);
})();

// Merchant-selected presentation sequence; this is not a live analytics feed.
(function initSellingFastCount(){
var count=document.getElementById('vopViewerCount');
if(!count){return;}
if(typeof window.vopViewerCountCleanup==='function'){window.vopViewerCountCleanup();}
var sequence=[16,23,20,37,41,35,44,40,48,37,27,19];
var index=0;
count.textContent=String(sequence[index]);
var timer=window.setInterval(function(){
if(!count.isConnected){cleanup();return;}
index=(index+1)%sequence.length;
count.textContent=String(sequence[index]);
},1600);
function onSectionUnload(event){if(event.target.contains(count)){cleanup();}}
function cleanup(){
window.clearInterval(timer);
document.removeEventListener('shopify:section:unload',onSectionUnload);
}
window.vopViewerCountCleanup=cleanup;
document.addEventListener('shopify:section:unload',onSectionUnload);
})();



